import Url from '../global/Url';
import { getCsrf } from './auth';

/**
 * Captura un lead de Fusión: lo registra en la bitácora y verifica si el número
 * es cliente Claro (pre/post) en pre_post_claro. Devuelve el resultado.
 */
export async function capturarFusion(datos) {
    const r = await fetch(Url.Api + 'fusion/capturar', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-CSRF': getCsrf() || '' },
        body: JSON.stringify(datos),
    });
    const data = await r.json();
    if (!r.ok || data.header !== 'OK') throw new Error(data.message || 'Error al capturar el lead');
    return data;
}

/** Lista de asesoras activas (para el modo manual). */
export async function listarAsesoras() {
    const r = await fetch(Url.Api + 'fusion/asesoras', { headers: { Accept: 'application/json' } });
    const data = await r.json();
    return { asesoras: data.asesoras || [], auto: data.auto || null };
}

/**
 * Asigna el lead capturado. modo: 'auto' (Mercedes) | 'manual' (gestor_id).
 *
 * Si el número ya se gestionó antes y no es una venta cerrada, el servidor responde
 * header 'CONFIRMAR' con el estado que tiene: NO es un error, es una pregunta. Se devuelve
 * tal cual para que la pantalla muestre qué pasó y el operador decida; repitiendo la llamada
 * con confirmar = true se asigna igual.
 */
export async function asignarFusion(id_bitacora, modo, gestor_id, confirmar = false) {
    const r = await fetch(Url.Api + 'fusion/asignar', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-CSRF': getCsrf() || '' },
        body: JSON.stringify({ id_bitacora, modo, gestor_id, confirmar }),
    });
    const data = await r.json();
    if (data.header === 'CONFIRMAR') return data;
    if (!r.ok || data.header !== 'OK') throw new Error(data.message || 'Error al asignar');
    return data;
}

/**
 * Busca una solicitud por SU ID de Fusión. Es la entrada principal de la pantalla:
 * si la solicitud ya está en la bitácora, trae todos sus datos (teléfono incluido).
 */
export async function buscarPorId(idFusion) {
    const id = String(idFusion || '').trim();
    if (id === '') return null;
    try {
        const r = await fetch(Url.Api + 'fusion/buscar-id/' + encodeURIComponent(id), { headers: { Accept: 'application/json' } });
        const d = await r.json();
        return d.existe ? d.datos : null;
    } catch { return null; }
}

/** Listado de asignaciones de Fusión (bitácora asignado=1 + estado real del CRM). */
/** Elimina un lead del CRM (assignmentnumbers + current_master) y de la bitácora de Fusión. */
export async function eliminarAsignacion(telefono) {
    const r = await fetch(Url.Api + 'deleteAsignacion/' + encodeURIComponent(telefono), { method: 'DELETE' });
    const data = await r.json();
    if (!r.ok || data.status !== 'success') throw new Error(data.message || 'No se pudo eliminar');
    return data;
}

export async function listarAsignacionesFusion(limit = 100, q = '') {
    let url = Url.Api + 'fusion/asignaciones?limit=' + limit;
    if (q && q.trim() !== '') url += '&q=' + encodeURIComponent(q.trim());
    const r = await fetch(url, { headers: { Accept: 'application/json' } });
    const data = await r.json();
    if (!r.ok || data.header !== 'OK') throw new Error(data.message || 'No se pudo cargar el listado');
    return data.rows || [];
}

/** Busca un número en la bitácora precargada; devuelve sus datos si existe. */
export async function buscarPrecargado(telefono) {
    const tel = String(telefono).replace(/\D/g, '');
    if (tel.length !== 9 && tel.length !== 10) return null;
    try {
        const r = await fetch(Url.Api + 'fusion/buscar/' + tel, { headers: { Accept: 'application/json' } });
        const d = await r.json();
        return d.existe ? d.datos : null;
    } catch { return null; }
}
